module.exports = __webpack_public_path__ + "img/armory.f941c606.jpg";